import { render, staticRenderFns } from "./engagement-layout.vue?vue&type=template&id=4c839a9e&scoped=true"
import script from "./engagement-layout.vue?vue&type=script&lang=js"
export * from "./engagement-layout.vue?vue&type=script&lang=js"
import style0 from "./engagement-layout.vue?vue&type=style&index=0&id=4c839a9e&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4c839a9e",
  null
  
)

export default component.exports